(function () {
  'use strict';
  var dialog = document.getElementById('jjt-support-menu');
  if (!dialog) return;
  var previousFocus;
  var previousOverflow;
  var launchTimer;
  var copy = window.JJTSupportCopy || {};
  var chat = dialog.querySelector('[data-jjt-support-chat]');
  var status = dialog.querySelector('[data-jjt-support-status]');
  function open() {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    status.hidden = true;
    chat.disabled = false;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dialog.querySelector('[data-jjt-support-close]').focus();
  }
  function close() { if (dialog.open) dialog.close(); }
  dialog.addEventListener('close', function () {
    clearInterval(launchTimer);
    document.body.style.overflow = previousOverflow || '';
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  });
  dialog.querySelector('[data-jjt-support-close]').addEventListener('click', close);
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;
    var bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-jjt-support-open]')) return;
    event.preventDefault();
    open();
  });
  dialog.querySelectorAll('details').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      dialog.querySelectorAll('details[open]').forEach(function (other) { if (other !== item) other.open = false; });
    });
  });
  chat.addEventListener('click', function () {
    clearInterval(launchTimer);
    chat.disabled = true;
    status.hidden = false;
    status.textContent = copy.loading;
    var attempts = 0;
    function ready() {
      var widget = document.querySelector('#redo-chat-widget');
      var root = widget && widget.shadowRoot;
      var launcher = root && root.querySelector('#chat-widget-button,[aria-label="Open chat widget"]');
      if (launcher) {
        clearInterval(launchTimer);
        close();
        document.dispatchEvent(new CustomEvent('jjt:open-chat'));
        return true;
      }
      if (++attempts >= 20) {
        clearInterval(launchTimer);
        chat.disabled = false;
        status.textContent = copy.unavailable;
        return true;
      }
      return false;
    }
    if (!ready()) launchTimer = setInterval(ready, 250);
  });
  window.JJTSupportMenu = { open: open, close: close };
})();
